import React from 'react';

import { styled, useTheme } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';

const StyPaper = styled(Paper)(({ theme }) => ({
    alignItems: 'center',
    borderColor: theme.palette.warning.main,
    borderRadius: theme.spacing(1),
    borderStyle: 'solid',
    borderWidth: theme.spacing(0.25),
    display: 'flex',
    marginBottom: theme.spacing(5),
    padding: theme.spacing(1),
}));

const WarningBanner = ({ message }: { message: string }): JSX.Element => {
    const theme = useTheme();
    return (
        <StyPaper>
            <WarningIcon
                fontSize="medium"
                color="warning"
                sx={{
                    margin: `0 ${theme.spacing(1)}`,
                }}
            />
            <Typography>{message}</Typography>
        </StyPaper>
    );
};

export default WarningBanner;
